var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"five columns"},[_c('div',{staticClass:"lotNumberContainer"},[_c('div',{staticClass:"lotNumber"},[_vm._v("\n      Lot "+_vm._s(_vm.podiumItem.display_lotnumber)+"\n    ")])]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.podiumItem.lead))])])
}
var staticRenderFns = []

export { render, staticRenderFns }